import { RubricState } from './Interfaces/RubricState';

const rubricInitialState: RubricState = {
    rubricData: null,
    rubricId: null,
    rubrics: null,
    rubricComponents: {
        columnsOfCategories: {},
        showFormToUpdateASubCategory: false,
        showRubricSettings: true,
        rubricId: null,
        initialNumberOfCategories: 0,
        updates: {
            newChanges: false,
            updatedCategories: [],
            newCategories: [],
            newQuestionsFromOldCategories: [],
            updatedQuestions: [],
            removedOldCategories: [],
            removedOldQuestions: [],
        },
    },
    rubricsId: JSON.parse(window.localStorage.getItem('selectedRubricIds')) || [],
};

export default rubricInitialState;
